import { FC } from 'react'
import { useIsMobile } from '@wellesley/ui'
import { CreatePost as CreatePostProps, Post } from '@wellesley/openapi'

import isQuote from '../../helpers/isQuote'
import FeedModal from '../../../PostFormButton/FeedModal'
import { PostForm } from '../../../PostForm'
import { FeedProps, UserWrapperProps } from '../../TimelineFeed/types'
import { usePostApiV1PostsByPostIdRepostMutation } from '../../../api'

type QuoteModalProps = {
  feed: Post
  isOpenModal: boolean
  onCloseModal(): void
  renderFeed: (props: FeedProps) => React.ReactNode
  renderUserWrapper: (props: UserWrapperProps) => JSX.Element
}

const QuoteModal: FC<QuoteModalProps> = ({
  isOpenModal,
  onCloseModal,
  renderFeed,
  renderUserWrapper,
  ...other
}) => {
  const isMobile = useIsMobile()
  const [repost] = usePostApiV1PostsByPostIdRepostMutation()

  const isQuotedRepost = isQuote(other.feed)

  const handleQuoteFeed = async (data: CreatePostProps) => {
    const id = isQuotedRepost
      ? other.feed.id
      : other.feed.originalPost?.id || other.feed.id

    await repost({
      postId: id,
      createPost: data,
    })
    onCloseModal()
  }

  const props = {
    ...other,
    feed: {
      ...other.feed,
      text: '',
      summary: '',
      poll: null,
      settings: {
        sensitive: false,
      },
    },
    onSubmit: handleQuoteFeed,
    className: 'max-w-[558px]',
  }

  if (!isOpenModal) return null

  const repostedContent = (
    <>
      <div className="my-m relative z-[-1] h-[1px] w-full bg-gray-200" />
      <div className="no-scrollbar pb-m z-[-1] max-h-[45vh] w-full overflow-auto">
        {renderFeed({
          ...(isQuote(other.feed)
            ? { ...other.feed, originalPost: undefined }
            : other.feed.originalPost || other.feed),
          className: 'py-0 pl-0',
          isFooter: false,
          isActions: false,
          isSmallImagePreview: false,
          renderUserWrapper,
          children: null,
        })}
      </div>
    </>
  )

  if (isMobile) {
    return (
      <FeedModal
        isOpenModal={isOpenModal}
        onCloseModal={onCloseModal}
        {...props}
      >
        {repostedContent}
      </FeedModal>
    )
  }

  return (
    <PostForm
      {...other}
      {...props}
      fillInit={false}
      isModal
      submitButtonText="Post"
      modalTitleText="Quote"
      isOpenModal={isOpenModal}
      onCloseModal={onCloseModal}
    >
      {repostedContent}
    </PostForm>
  )
}

export { QuoteModal }
